export default __webpack_public_path__ + "static/media/avatar_panda7.17e2013a.mp3";